import { Markdown } from '@signavio/effektif-commons';
import { Field, handleUnnamedField, FutureField } from '@signavio/effektif-fields';
import { Stack } from '@signavio/ui/core';
import { FadeTransition } from '../transitions';
import GroupInstance from './GroupInstance';
import { jsx as _jsx } from "react/jsx-runtime";
function FormTree({
  errors,
  elements = [],
  onComplete,
  readOnly,
  newFieldsDesign = true
}) {
  return /*#__PURE__*/_jsx(Stack, {
    spacing: "xxsmall",
    children: elements.map((element, index) => {
      return /*#__PURE__*/_jsx(FadeTransition, {
        required: element.required,
        visible: element.visible ?? true,
        children: element.elementType === 'fieldGroupInstance' ? /*#__PURE__*/_jsx(GroupInstance, {
          groupInstance: element,
          readOnly: readOnly || element.readOnly,
          children: /*#__PURE__*/_jsx(FormTree, {
            errors: errors,
            elements: element.elements,
            onComplete: onComplete,
            readOnly: readOnly
          })
        }) :
        // newFieldDesign is needed in the condition because otherwise tests in
        // ServiceAction fails which renders Form with newFieldDesign = false
        newFieldsDesign ? /*#__PURE__*/_jsx(FutureField, {
          labelPosition: "left"
          // Ivestigate to remove the casting here when refactoring complex field like Money or Connector
          ,
          value: element.value,
          type: element.type,
          errors: errors[element.id],
          resolvedParameters: element.resolvedParameters,
          required: element.required,
          label: handleUnnamedField(element),
          description: element.description ? /*#__PURE__*/_jsx(Markdown, {
            children: element.description
          }) : undefined,
          readOnly: readOnly || element.readOnly,
          onComplete: newValue => {
            onComplete(newValue, element.id);
          }
        }) : /*#__PURE__*/_jsx(Field, {
          id: element.id,
          value: element.value,
          type: element.type,
          errors: errors[element.id],
          resolvedParameters: element.resolvedParameters,
          required: element.required,
          label: handleUnnamedField(element),
          description: element.description,
          readOnly: readOnly || element.readOnly,
          onComplete: onComplete,
          newFieldsDesign: newFieldsDesign
        })
      }, element.id);
    })
  });
}
export default FormTree;